import * as ChatOrigins from './constants';

export const otherMappings = (url: string) => {
  return [
    /** START new mapping additions that were not part of old ChatAI **/
    [/\/vehicle\/\d+/, ChatOrigins.VEHICLE_DETAILS_PAGE],
    /** END new mapping additions that were not part of old ChatAI **/

    [/\/(learn-financing|auto-loan-calculator)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_FINANCING],
    [/\/(help\/payment-and-financing)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_FINANCING],
    [/\/(about-us|how-it-works|certified-program)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_ABOUT],
    [/\/(app)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_APP],
    [/\/(reviews|referral)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_OTHER],
    [/\/(terms-of-use)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_LEGAL],
    [/\/(careers)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_CAREERS],
    [/\/(contact-us)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_CONTACTS],
    [/\/(error)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_ERROR],
    [/\/(info\/contactus)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_CONTACTS],
    [/\/(vehicle-protection-plans)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_ANCILLARY],
    [/\/(post-sale-dashboard)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_POST_ORDER],
    [/\/(contracts)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_CONTRACTS],
    [/\/(sellyourcar\/(.+)origin=bfp)(#|$)/, ChatOrigins.TRADE_ORIGIN_BFP],
    [/\/(sell-my-car\/(.+)origin=bfp)(#|$)/, ChatOrigins.TRADE_ORIGIN_BFP],
    [/\/(sellyourcar\/(.+)\/documentsreview)(\/|#|$)/, ChatOrigins.TRADE_ORIGIN_DOCUMENT_REVIEW],
    [/\/(sell-my-car\/(.+)\/documentsreview)(\/|#|$)/, ChatOrigins.TRADE_ORIGIN_DOCUMENT_REVIEW],
    [/\/(trades\/new(.+)vin=)(\/|#|$)/, ChatOrigins.TRADE_ORIGIN_NEW],
    [/\/(trades\/breakdown(.+)source=trade)(\/|#|$)/, ChatOrigins.TRADE_ORIGIN_BREAKDOWN],
    [/\/(underwriting\/(.+)\/trade)(\/|#|$)/, ChatOrigins.TRADE_ORIGIN_UNDERWRITING],
    [/\/(sellyourcar)(\?|\/|#|$)/, ChatOrigins.TRADE_ORIGIN_DEFAULT],
    [/\/(selling-or-trades-how-it-works)(\?|\/|#|$)/, ChatOrigins.TRADE_ORIGIN_DEFAULT],
    [/\/(sell-my-car)(\?|\/|#|$)/, ChatOrigins.TRADE_ORIGIN_DEFAULT],
    [/\/(underwriting)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_UNDERWRITING],

    [/\/(auto-loan-approval)(\?|\/|#|$)/, ChatOrigins.FINANCE_BAD_CREDIT],
    [/\/(vehiclecoverage)(\?|\/|#|$)/, ChatOrigins.VEHICLE_COVERAGE],

    [/\/(touchless-delivery)(\?|\/|#|$)/, ChatOrigins.CARVANA_TOUCHLESS],
    [/\/(account\/login)(\?|\/|#|$)/, ChatOrigins.MISC_ORIGIN_ACCOUNT],

    [/localhost:3000/, ChatOrigins.LOCAL_HOST],
  ];
};
